import React from "react";

import iconePdf from "assets/images/svgs/icone-pdf.svg";
import { DocumentoMimeType } from "core/features/documentos/typings";
import { Image } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";
import { AiOutlineFile, AiOutlineFileImage } from "react-icons/ai";

const Wrapper = ({ children }: { children: React.ReactNode }) => (
  <Flex
    borderColor={colors.black50}
    borderWidth={1}
    w="70px"
    h="70px"
    rounded={8}
    justifyContent="center"
    alignItems="center"
  >
    {children}
  </Flex>
);

export default function DocumentoIcone({
  mimetype,
}: {
  mimetype?: DocumentoMimeType | null;
}) {
  if (mimetype === "application/pdf") {
    return (
      <Wrapper>
        <Image src={iconePdf} w="82%" h="82%" ml={-1} />
      </Wrapper>
    );
  }

  if (mimetype?.startsWith("image")) {
    return (
      <Wrapper>
        <AiOutlineFileImage size={32} color={colors.blue300} />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <AiOutlineFile size={32} color={colors.blue300} />
    </Wrapper>
  );
}
